import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Button, Chip, Stack } from '@mui/material';
import HotelIcon from '@mui/icons-material/Hotel';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

export const tips = [
  {
    title: 'Change Bedding Weekly',
    description: 'Wash and replace sheets and pillowcases every week for a fresh and healthy sleep environment.',
  },
  {
    title: 'Dust Nightstands',
    description: 'Wipe down nightstands, lamps, and headboards to remove dust and allergens.',
  },
  {
    title: 'Vacuum Under the Bed',
    description: "Don't forget to vacuum or sweep under the bed to prevent dust bunnies.",
  },
  {
    title: 'Pro Tip: Freshen Mattress',
    description: 'Sprinkle baking soda on your mattress, let sit 30 minutes, then vacuum to remove odors.',
    pro: true,
  },
  {
    title: 'Organize Closets',
    description: 'Sort and organize clothes, shoes, and accessories monthly to keep clutter at bay.',
  },
  {
    title: 'Clean Mirrors and Windows',
    description: 'Wipe down mirrors and windows for a brighter, more inviting bedroom.',
  },{
    title: 'Dust-mite Armor',
    description: 'Encase mattress and pillows in certified allergen-barrier covers. Vacuum weekly with a HEPA-filter vacuum to starve dust mites of skins and dander.',
  },
  {
    title: 'Curtain & Blind Revival',
    description: 'Swap fabric curtains onto a shower rod and steam-clean in place—no removal needed. For blinds, wrap a microfiber cloth around tongs and snap through each slat.',
  },
  {
    title: 'Under-Bed Strategem',
    description: 'Use low-profile rolling bins with sealed lids for off-season storage. Slide them under the bed to keep dust out and access easy.',
  },
  {
    title: 'Closet Micro-Climate',
    description: 'Place bamboo charcoal bags on shelves to absorb humidity and odors. Change them every six months—and your clothes will smell noticeably fresher.',
  },
  {
    title: 'Upholstered Headboard TLC',
    description: 'Treat fabric headboards quarterly with a upholstery-safe enzyme cleaner to lift skin oils before they set into stains or yellowing.',
  },
  {
    title: 'Mattress Rotation Calendar',
    description: 'Mark your calendar to flip (if double-sided) and rotate your mattress every three months. Extends comfort and prevents permanent sagging.',
  }
];

const BedroomTips = () => (
  <Box sx={{ mb: 6 }}>
    <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
      <HotelIcon color="primary" sx={{ fontSize: 40 }} />
      <Typography variant="h4" fontWeight={700}>
        Bedroom Cleaning Tips
      </Typography>
    </Stack>
    <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
      Sleep better in a clean, organized bedroom with these tips!
    </Typography>
    <Grid container spacing={3}>
      {tips.map((tip, idx) => (
        <Grid item xs={12} sm={6} md={4} key={idx}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 1 }}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="h6" fontWeight={600} sx={{ flexGrow: 1 }}>
                  {tip.title}
                </Typography>
                {tip.pro && (
                  <Chip icon={<EmojiObjectsIcon />} label="Pro Tip" color="warning" size="small" />
                )}
              </Stack>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                {tip.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Button variant="contained" color="primary" size="large">
        See all bedroom tips
      </Button>
    </Box>
  </Box>
);

export default BedroomTips; 